import { h, render, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import RecommendedProductsSlider from './recommended-products-slider';
import Storefront from '../utils/storefront';
import * as queries from '../utils/storefront/queries';
import { formatProducts } from '../utils/storefront/format-resource';
import { getProductsForCard } from '../utils/helpers';

export default (element, data) => {
  const storefront = new Storefront();

  const getCollectionProducts = async (id) => {
    const response = await storefront.request({
      query: queries.collectionById,
      variables: { id, first: 6 },
    });
    return response;
  };

  const collectProducts = async () => {
    const promises = data.tabs
      .filter((tab) => !tab.isExcluded)
      .map(async (tabInfo) => {
        if (!tabInfo.collectionId) return Promise.resolve([]);
        const encodedCollectionId = window.btoa(
          `gid://shopify/Collection/${tabInfo.collectionId}`,
        );

        const products = await getCollectionProducts(encodedCollectionId)
          .then((response) => {
            const filteredProducts = response.data.node.products.edges.filter(
              (p) => p,
            );
            return Promise.resolve(formatProducts(filteredProducts));
          })
          .catch((error) => {
            /* eslint-disable-next-line no-console */
            console.error(error);
          });

        return getProductsForCard(products);
      });
    return Promise.all(promises);
  };

  const Recommended = ({ collectedProducts }) => {
    const [currentIndex, setcurrentIndex] = useState(0);

    useEffect(() => {
      if (window.yotpo?.initWidgets) {
        let attempts = 0;
        const interval = setInterval(() => {
          if (
            document.querySelectorAll(
              '.yotpo-widget-container .yotpo-bottom-line-scroll-panel',
            ).length > 0 ||
            attempts > 10
          ) {
            clearInterval(interval);
          }
          attempts += 1;
          window.yotpo.refreshWidgets(
            document.querySelector('[data-section="recommended-products"]'),
          );
        }, 100);
      }
    }, []);

    return (
      <>
        <div className="py-[55px] pl-5 laptop:px-5 laptop:pl-10 pr-0">
          <div className="mb-5">
            <p className="subheading-3">{data.sectionHeading}</p>
          </div>
          <div className="flex items-start justify-between laptop:pr-10">
            <div className="mb-[30px] flex justify-start gap-3 laptop:gap-10 items-center flex-wrap">
              {data.tabs
                .filter((tab) => !tab.isExcluded)
                .map((data, index) => (
                  <button
                    type="button"
                    key={index}
                    data-tab-heading={index}
                    className={`mb-0 laptop:mb-[30px] cursor-pointer ${
                      index === currentIndex ? '' : 'text-secondary-1'
                    }`}
                    data-tab-active={index === currentIndex}
                    onClick={() => setcurrentIndex(index)}
                    aria-pressed={index === currentIndex}
                    aria-label={`Tab ${index + 1}: ${data.heading}`}
                  >
                    <p className="heading-4">{data.heading}</p>
                  </button>
                ))}
            </div>
            {data.ctaText && data.ctaUrl && (
              <a
                href={data.ctaUrl}
                className="hidden btn-primary-stroke-arrow laptop:block"
              >
                {data.ctaText}
              </a>
            )}
          </div>
          <div>
            {data.tabs
              .filter((tab) => !tab.isExcluded)
              .map((data, index) => (
                <RecommendedProductsSlider
                  key={index}
                  tabInfo={data}
                  index={index}
                  collectProducts={collectedProducts[index]}
                  currentIndex={currentIndex}
                />
              ))}
          </div>
          {data.ctaText && data.ctaUrl && (
            <a
              href={data.ctaUrl}
              className="btn-primary-stroke-arrow block laptop:hidden max-w-[calc(100%-20px)] laptop:max-w-full"
            >
              {data.ctaText}
            </a>
          )}
        </div>
      </>
    );
  };

  const init = async () => {
    const collectedProducts = await collectProducts();
    render(<Recommended collectedProducts={collectedProducts} />, element);
  };

  init();
};
